/**
 * Web stand-in for `react-native-camera-kit`.
 *
 * Only consumer: src/features/adopt-device/ui/ScanDeviceScreen.tsx, which
 * renders <Camera scanBarcode .../> to read a terminal's pairing QR. There is
 * no camera-to-QR pipeline here, and that screen keeps its manual code field
 * visible at all times — so the whole flow stays completable in a browser.
 *
 * What this must NOT do is render an empty box: a blank rectangle where a
 * viewfinder belongs reads as a camera that failed to start, and the user waits
 * for it instead of typing the code sitting right below. So it says so.
 */
import React from 'react';
import {StyleSheet, Text, View} from 'react-native';

const styles = StyleSheet.create({
  box: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    gap: 8,
  },
  title: {
    fontSize: 15,
    fontWeight: '600',
    textAlign: 'center',
    color: '#e6e6e6',
  },
  hint: {
    fontSize: 13,
    textAlign: 'center',
    color: '#9aa0a6',
  },
});

export function Camera(props) {
  return React.createElement(
    View,
    {style: [props.style, styles.box], testID: 'camera-kit-web-stub'},
    React.createElement(
      Text,
      {style: styles.title, key: 'title'},
      'Сканирование QR доступно только в мобильном приложении',
    ),
    React.createElement(
      Text,
      {style: styles.hint, key: 'hint'},
      'Введите код устройства вручную в поле ниже.',
    ),
  );
}

export default {Camera};
